// apps/web/src/components/tenants/TenantList.tsx
// Sample component showing how the tenant management UI would be structured

import { useState, useEffect } from 'react';
import type { Tenant } from '../../types/tenant';
import { apiClient } from '../../lib/apiClient';

interface TenantListProps {
  onTenantSelect?: (tenantId: string) => void;
}

export function TenantList({ onTenantSelect }: TenantListProps) {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get('/api/v1/tenants');
        setTenants(response.data.tenants);
      } catch (err) {
        setError('Failed to load tenants');
        console.error('Error loading tenants:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTenants();
  }, []);

  if (loading) {
    return <div className="loading">Loading tenants...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="tenant-list">
      <h2>Tenants</h2>
      <div className="tenants-grid">
        {tenants.map(tenant => (
          <div 
            key={tenant.id} 
            className="tenant-card"
            role="button"
            tabIndex={0}
            onClick={() => onTenantSelect?.(tenant.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') onTenantSelect?.(tenant.id);
            }}
          >
            <h3>{tenant.name}</h3>
            <p>Status: {tenant.status}</p>
            <p>Created: {new Date(tenant.createdAt).toLocaleDateString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
}